import React, { useState } from 'react';
import { submissionURL } from '../graphic';

import {
  Checkbox,
  Button,
  Grid,
  FormControl,
  FormHelperText,
  FormControlLabel,
  RadioGroup,
  Radio,
  InputAdornment,
  FormLabel,
  IconButton,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function stripCommas(x) {
  return x.replace(/,/g, '');
}


function Form(props) {
  const { classes } = props;

  const [submission, setSubmission] = useState({
    income: '',
    familySize: '',
    location: 'lower48',
    resultText: '',
  });

  const [userAgrees, setUserAgreement] = useState(false);
  const [resError, setResError] = useState(false);
  const [open, setOpen] = useState(false);
  const [submitted, storySubmitted] = useState(false);

  function handleLocationChange(event) {
      const { target } = event;
      const { value } = target;
        setSubmission({
        ...submission,
        location: value,
      });

  }

  function handleChange(event) {
    const { target } = event;
    const { id, value } = target;

    if ( (id == 'income') || (id == 'familySize') ) {
        if (isNaN(parseInt(value))) {
            setSubmission({
                ...submission,
                [id]: '',
            });
        } else {
            setSubmission({
                ...submission,
                [id]: numberWithCommas(Math.abs(parseInt(stripCommas(value)))),
            });
        }

    } else {
        setSubmission({
          ...submission,
          [id]: value,
        });

    }
  }

  function setLocation(event) {
    const { target } = event;
    const { id, value } = target;

      setSubmission({
        ...submission,
        location: value,
      });
  }

  function handleAgreement(event) {
    setUserAgreement(!userAgrees);
  }

  function handleSubmit(event) {
    event.preventDefault();
    storySubmitted(true);

    let i = parseInt(stripCommas(submission.income));
    let f = parseInt(stripCommas(submission.familySize));
    let baseLine = 0;

    if (submission.location == 'lower48') {
        switch(f) {
            case 1:
              baseLine = 14580;
              break;
            case 2:
              baseLine = 19720;
              break;
            case 3:
              baseLine = 24860;
              break;
            case 4:
              baseLine = 30000;
              break;
            case 5:
              baseLine = 35140;
              break;
            case 6:
              baseLine = 40280;
              break;
            case 7:
              baseLine = 45420;
              break;
            case 8:
              baseLine = 50560;
              break;
            default:
              baseLine = 50560 + ( (f-8) * 5140);
        }
    } else if (submission.location == 'alaska') {
        switch(f) {
            case 1:
              baseLine = 18210;
              break;
            case 2:
              baseLine = 24640;
              break;
            case 3:
              baseLine = 31070;
              break;
            case 4:
              baseLine = 37500;
              break;
            case 5:
              baseLine = 43930;
              break;
            case 6:
              baseLine = 50360;
              break;
            case 7:
              baseLine = 56790;
              break;
            case 8:
              baseLine = 63220;
              break;
            default:
              baseLine = 63220 + ( (f-8) * 6430);
        }
    } else if (submission.location == 'hawaii') {
        switch(f) {
            case 1:
              baseLine = 16770;
              break;
            case 2:
              baseLine = 22680;
              break;
            case 3:
              baseLine = 28590;
              break;
            case 4:
              baseLine = 34500;
              break;
            case 5:
              baseLine = 40410;
              break;
            case 6:
              baseLine = 46320;
              break;
            case 7:
              baseLine = 52230;
              break;
            case 8:
              baseLine = 58140;
              break;
            default:
              baseLine = 58140 + ( (f-8) * 5910);
        }
    }

    let discretionaryIncome = i - (baseLine * 2.25);
    let payment = Math.round(discretionaryIncome * .1 / 12);

    setSubmission({
      ...submission,
      ["resultText"]: payment < 0 ? 0 : numberWithCommas(payment),
    });

    setOpen(true);
    window.setTimeout(() => {pymChild.sendHeight();}, 100);
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <form className={classes.form}>
      <Grid className={classes.root} container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            id='income'
            fullWidth={true}
            // rows={10}
            // variant='outlined'
            label='What‘s your annual income?'
            // helperText="Adjusted gross income from most recent tax return"
            value={submission.income}
            onChange={handleChange}
            className={classes.textField}
            error={false}

            InputLabelProps={{
              classes: {
                animated: classes.animatedInput,
                root: classes.rootInput,
                shrink: classes.focusedInput,
              },
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id='familySize'
            fullWidth={true}
            // rows={10}
            // variant='outlined'
            label='How many people are in your family?'
            // helperText="Include yourself in this number"
            value={submission.familySize}
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              classes: {
                animated: classes.animatedInput,
                root: classes.rootInput,
                shrink: classes.focusedInput,
              },
            }}
          />
        </Grid>

{/*
        <Grid item xs={12}>
          <Typography className={classes.disclaimer} variant='subtitle2'>
            If you are married but filing separately, do not include your spouse's income and do not include them in your family size.
          </Typography>
        </Grid>
*/}
{/*
        <Grid item xs={12}>
          <FormControl component="fieldset">
          <FormLabel component="legend">Where do you live?</FormLabel>
          <RadioGroup
            defaultValue={submission.location}
            id="location"
            name="location"
            onChange={handleLocationChange}
            row
          >
            <FormControlLabel
              value="lower48"
              control={<Radio />}
              label="Contiguous 48 or DC"
            />
            <FormControlLabel
              value="alaska"
              control={<Radio />}
              label="Alaska"
            />
            <FormControlLabel
              value="hawaii"
              control={<Radio />}
              label="Hawaii"
            />

          </RadioGroup>
          </FormControl>
        </Grid>
*/}
        <Grid style={{
          paddingBottom: 24,
        }} item xs={12}>
          <Button
            disabled={!submission.income.length || !submission.familySize.length}
            className={classes.button}
            variant='contained'
            color="primary"
            size='medium'
            onClick={handleSubmit}>
            {submitted ? 'Recalculate' : 'Calculate'}
          </Button>
        </Grid>
      </Grid>

      {open ? (
      <Grid style={{
        paddingTop: 4, paddingBottom: 12
      }} item xs={12}>
        <Typography
            // gutterBottom
            variant="body2"
            open={open}
            className={classes.lead}
            dangerouslySetInnerHTML={{
              __html: `Based on your responses, your estimated monthly payment will be  <span style="font-weight:bold;color:#cc0000;">$${
                submission.resultText
              }</span>.`,
            }}
          />

          <Typography className={classes.disclaimer} variant='subtitle2'>
            Note: The estimated payment is not official. Your student loan servicer will calculate your actual monthly payment under the SAVE plan. <a href="http://www.cnn.com/2023/09/21/politics/save-student-loan-payment-calculator/index.html">Read more</a>
          </Typography>
        </Grid>
        ) : null}

    </form>
  );
}

export default Form;
